import dotenv from 'dotenv'
import fs from 'fs'
import path from 'path'

import { isBrowser } from '@app/utils/isBrowser'
import { parseBooleanString } from '@app/utils/parseBooleanString'

dotenv.config()

interface RuntimeConfig {
  joinSproutTherapyConfig?: Record<keyof typeof joinSproutTherapyConfig, any>
  isDev?: boolean
  API_ENDPOINT?: string
  API_ENDPOINT_GRAPH_CMS?: string
  TEST_HEADER?: boolean
  API_ENDPOINT_PROVIDER?: string
  PROVIDER_BASE_URL?: string
  PARENT_BASE_URL?: string
  GREENHOUSE_ID?: string
  isBrowser?: boolean
  SPROUT_BASE_URL?: string
  SENTRY_DSN?: string
  ENV_NAME?: string
  SEGMENT_API_KEY?: string
  SEGMENT_API_KEY_DEV?: string
  REFERRAL_FORM_LINK?: string
}

export function loadEnvs() {
  const files = ['.env.release', '.env']
  let envs = {}
  for (let file of files) {
    file = path.resolve(`${__dirname}/${file}`)
    if (fs.existsSync(file)) {
      const env = require('dotenv').config({ path: file })
      envs = { ...envs, ...env.parsed }
    }
  }
  return envs
}

const joinSproutTherapyConfig = {
  GTM_ID: process.env.GTM_ID, // 'GTM-M8L77GG'
  GA_ID: process.env.GA_ID, // 'UA-157564127-2',
  GADS_ID: process.env.GADS_ID, // 'AW-658106055',
  GO_EXPERIMENT_ID_LOCATION_FILTER: process.env.GO_EXPERIMENT_ID_LOCATION_FILTER, // 'nLy6lLQ-QpSUH7HFMcMlQA'
  GO_CONTAINER_ID: process.env.GO_CONTAINER_ID, // 'OPT-P5WMW29'
  INTERCOM_ID: process.env.INTERCOM_ID, // zk7chmyp - prod / u42b1qmy - dev
  FB_ID: process.env.FB_ID, // '1611063472374137',
  THESIS_ID: process.env.THESIS_ID, // 'ny5t8y46'
  CTM_ID: process.env.CTM_ID, // '247109'
  SEGMENT_ID: process.env.SEGMENT_ID,
  CHANNEL_ID: process.env.CHANNEL_ID, // '00000000-0000-0000-0000-000000000000',
  RELEASE_VERSION: process.env.RELEASE_VERSION,
  CDN_HOST: process.env.CDN_HOST,
  ASSET_PREFIX: process.env.CDN_HOST
    ? `https://${process.env.CDN_HOST}/web/${process.env.ENV_NAME}/${process.env.RELEASE_VERSION}`
    : '',
  SENTRY_DSN: process.env.SENTRY_DSN,
  ENV_NAME: process.env.ENV_NAME,
  SERVICE_ID: process.env.SERVICE_ID,
  REFERRAL_FORM_LINK: process.env.REFERRAL_FORM_LINK // https://app.smartsheet.com/b/form/26808ade382b48de821757ec8b6fb9d6
}

let runtimeConfig: RuntimeConfig = {}
if (isBrowser) {
  // in browser we read the runtimeConfig from global variable passed by server
  // @ts-ignore
  runtimeConfig = window.__RUNTIME_CONFIG__
} else {
  // load ENVIRONMENT variables from env files into process.env
  loadEnvs()
  runtimeConfig = {
    joinSproutTherapyConfig,
    isBrowser,
    API_ENDPOINT: process.env.API_ENDPOINT,
    API_ENDPOINT_GRAPH_CMS: process.env.API_ENDPOINT_GRAPH_CMS,
    TEST_HEADER: parseBooleanString(process.env.TEST_HEADER),
    API_ENDPOINT_PROVIDER: process.env.API_ENDPOINT_PROVIDER,
    PROVIDER_BASE_URL: `${process.env.PROVIDER_BASE_URL}/?redirectTo={redirectTo}`,
    PARENT_BASE_URL: process.env.PARENT_BASE_URL,
    SPROUT_BASE_URL: process.env.SPROUT_BASE_URL,
    GREENHOUSE_ID: process.env.GREENHOUSE_ID,
    SEGMENT_API_KEY: process.env.SEGMENT_API_KEY,
    SEGMENT_API_KEY_DEV: process.env.SEGMENT_API_KEY_DEV,
    isDev: process.env.NODE_ENV !== 'production'
  }
}

export { runtimeConfig }
